var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" " + _vm._s(_vm.alert.alert_title) + " ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.alert.service))]),
                  _c("div", [
                    _vm._v("Current usage - " + _vm._s(_vm.alert.currentUsage))
                  ]),
                  _c("div", [
                    _vm._v(
                      "Alert Threshold - " + _vm._s(_vm.alert.alertThreshold)
                    )
                  ]),
                  _c("div", [
                    _vm._v("Created: " + _vm._s(_vm.alert.created_at))
                  ]),
                  _c("div", [
                    _vm._v(
                      "Last Notified: " + _vm._s(_vm.alert.last_notified_at)
                    )
                  ]),
                  _vm.alert.subaccount_username
                    ? _c("div", [
                        _vm._v(
                          "cPanel Username: " +
                            _vm._s(_vm.alert.subaccount_username)
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.alert.alert_description) + " ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-capitalize text-center",
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-1",
                      attrs: {
                        small: "",
                        color: _vm.statusColor(_vm.alert.status)
                      }
                    },
                    [_vm._v(" mdi-circle ")]
                  ),
                  _vm._v(" " + _vm._s(_vm.alert.status) + " ")
                ],
                1
              ),
              _vm.viewDetails
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "3"
                      }
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            to: "/alerts/".concat(_vm.alert.id)
                          }
                        },
                        [_vm._v("View Details")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }